import { default as BSAlert } from 'bootstrap/js/src/alert'

class Alert extends BSAlert {}

export default Alert
